import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useCallback } from 'react';
import Icon from './Icon';
var iconPaths = {
  fill: 'checkbox-0',
  minus: 'checkbox-1',
  checked: 'checkbox-2'
};
var scaleStyles = {
  visibility: 'visible',
  transform: 'scale(1)',
  transition: 'all 120ms ease-out'
};
var initialStyles = {
  flexShrink: 0,
  outline: 0,
  cursor: 'pointer',
  ' .ui-kit-Checkbox-Fill ': {
    transform: 'scale(1)',
    transformOrigin: 'center center',
    transition: 'all 180ms ease-out'
  },
  ' .ui-kit-Checkbox-Minus, .ui-kit-Checkbox-Checked ': {
    fill: '#fff',
    visibility: 'hidden',
    transform: 'scale(0)',
    transformOrigin: 'center center',
    transition: 'all 180ms ease-out'
  },
  ' &:hover, &:focus ': {
    ' .ui-kit-Checkbox-Fill ': {
      transform: 'scale(1.125)'
    }
  },
  ' &:active ': {
    ' .ui-kit-Checkbox-Fill ': {
      transform: 'scale(1)'
    }
  }
};
var checkedStyles = {
  ' .ui-kit-Checkbox-Checked ': scaleStyles
};
var indeterminateStyles = {
  ' .ui-kit-Checkbox-Minus ': scaleStyles
};

function CheckboxCell(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      indeterminate = _ref.indeterminate,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, ["checked", "disabled", "indeterminate", "onBlur", "onChange", "onFocus", "size"]);

  var handleChange = useCallback(function (event) {
    event.preventDefault();

    if (onChange) {
      onChange(event);
    }
  }, [onChange]);
  var cssStyles = [initialStyles];

  if (checked) {
    cssStyles.push(checkedStyles);
  }

  if (indeterminate) {
    cssStyles.push(indeterminateStyles);
  }

  return /*#__PURE__*/React.createElement(Icon, {
    size: size,
    tabIndex: 0,
    role: "checkbox",
    "aria-checked": indeterminate ? 'mixed' : checked,
    "aria-disabled": disabled,
    onBlur: onBlur,
    onFocus: onFocus,
    onClick: handleChange,
    onKeyDown: function onKeyDown(event) {
      return event.key === ' ' && handleChange(event);
    },
    className: "uikit-reset ui-kit-Checkbox",
    css: cssStyles
  }, /*#__PURE__*/React.createElement(Icon.Path, {
    name: iconPaths.fill,
    className: "uikit-reset ui-kit-Checkbox-Fill",
    fill: checked || indeterminate ? 'primary' : 'surfaceTertiary',
    stroke: checked || indeterminate ? 'primary' : 'separatorSecondary'
  }), /*#__PURE__*/React.createElement(Icon.Path, {
    name: iconPaths.minus,
    className: "uikit-reset ui-kit-Checkbox-Minus"
  }), /*#__PURE__*/React.createElement(Icon.Path, {
    name: iconPaths.checked,
    className: "uikit-reset ui-kit-Checkbox-Checked"
  }));
}

export default CheckboxCell;